export default "__VITE_ASSET__CDPjFa_V__"